import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Icono de sidebar (public/icons/sidebar-*.svg) embebido en línea para que herede `currentColor`
 * del botón que lo aloja: así sigue el tema claro/oscuro de la app, que se controla por clase y no
 * por `prefers-color-scheme`. `open` alterna `is-open`, el estado con el panel relleno.
 *
 * El contraste de las barras se puede ajustar con `--mb-sidebar-icon-contrast`.
 */
@Component({
  selector: 'app-sidebar-icon',
  standalone: true,
  templateUrl: './sidebar-icon.component.html',
  styleUrl: './sidebar-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarIconComponent {
  @Input() open = false;
}
